<template>
    <div class="hamburger hamburger--elastic" :class="( this.isOpen ? 'is-active' : '' )" @click="this.toggleNav">
        <div class="hamburger-box">
            <div class="hamburger-inner"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Hamburger",
        data: function() {
            return {
                isOpen: false
            }
        },
        methods: {
            toggleNav: function() {
                this.isOpen = !this.isOpen

                this.$root.$emit('toogleMainNav', this.isOpen)
            }
        }
    }
</script>
